import React, { useCallback } from 'react';
import './PayNow.scss';

function getLoader(view) {
  return view === 'desktop' ? (
    <div className="loaderLK">
      <div className="barLK"></div>
      <div className="barLK"></div>
      <div className="barLK"></div>
    </div>
  ) : (
    <span className="pd-t8 pd-b8 icon-spinner animate-spin" data-testid="spinnerIcon"></span>
  );
}

function ConfirmCOD(props) {
  const { view, loading, codConfirmation, dataLocale, listing } = props;
  const btnLoader = useCallback(getLoader.bind(null, view), []);
  const clickHandlerFn = useCallback(() => {
    const trackEnv = view === 'desktop' ? 'dtm' : 'mobileGA';
    if (window[trackEnv].LenskartRewamp) {
      window[trackEnv].LenskartRewamp.myaccount?.myOrderStatusEventsClick(listing, 'confirm cod');
    }
    codConfirmation();
  }, []);
  const { CONFIRM_YOUR_COD_ORDER, CONFIRM_ORDER_CONFIRMATION, CONFIRM_ORDER } = dataLocale;
  return (
    <div
      className={`order-pay-now bora-8 justify-space-between align-items-center display-flex ${
        view === 'desktop'
          ? 'desktop padding-12 bg-color-white margin-t10 margin-b15 margin-l20 margin-r20'
          : 'mr-t10 bg-color_white pd-12'
      }`}
    >
      <div className={`${view === 'desktop' ? 'flex-basis-80' : 'flex-basis-76'}`}>
        <div
          className={`${
            view === 'desktop' ? 'text-color-33 fs16' : 'text-color_grey_black fsp12'
          } fw700`}
          data-testid="confirmText"
        >
          {CONFIRM_YOUR_COD_ORDER}
        </div>
        <div
          className={`${
            view === 'desktop' ? 'text-color-33 fs14' : 'text-color_grey_black fsp12'
          } lh-14`}
        >
          {CONFIRM_ORDER_CONFIRMATION}
        </div>
      </div>
      <div
        className={`${
          view === 'desktop'
            ? 'text-color-white bg-color-primary no-decoration flex-basis-20 display-flex justify-content-center'
            : 'bg-color_link_blue text-color_white flex-basis-24'
        } text-center bora-4 block cursor-pointer fw700`}
        style={{ minHeight: view === 'desktop' ? '34px' : '' }}
        onClick={clickHandlerFn}
      >
        {loading ? (
          btnLoader()
        ) : (
          <div
            className={`${
              view === 'desktop' ? 'padding-t10 padding-b10 fs14' : 'pd-t8 pd-b8'
            } text-uppercase`}
          >
            {CONFIRM_ORDER}
          </div>
        )}
      </div>
    </div>
  );
}

export default ConfirmCOD;
